export default "__VITE_ASSET__CinPiQyd__"